import React from 'react'
import styled from 'styled-components';

export const OnboardingMenu = styled.div`
    margin-top: 20px;
    margin-right: 30px;
    padding: 5px 15px;
    min-width: 200px;
`;
